import { classnames } from 'helpers/utils';
import styles from './onboarding-tooltip.module.scss';

type OnboardingTooltipProps = {
  // Centers the pointer under New (its width).
  anchorWidth: number;
  // Over the anchor, pointing down (the phone bottom bar's "+").
  above?: boolean;
  onDismiss: () => void;
};

// Shown under New after the returning-customer introduction, until a memory
// is added (Figma: GS UI / Design System, node 32555:141232).
export const OnboardingTooltip = ({
  anchorWidth,
  above = false,
  onDismiss,
}: OnboardingTooltipProps) => (
  <div
    className={classnames(styles.tooltip, { [styles.above]: above })}
    role="status"
    data-onboarding-tooltip
    style={{ right: anchorWidth / 2 - 24 }}
  >
    <svg
      className={styles.pointer}
      width="16"
      height="6"
      viewBox="0 0 16 6"
      aria-hidden="true"
    >
      <path d="M0 6H16L8 0L0 6Z" fill="currentColor" />
    </svg>
    <div className={styles.content}>
      <p className={styles.title}>Add something worth preserving.</p>
      <p className={styles.text}>
        Upload files, write a memory, record, or start a conversation.
      </p>
      <button type="button" className={styles.dismiss} onClick={onDismiss}>
        Dismiss
      </button>
    </div>
  </div>
);
